<p-toast position="bottom-center"></p-toast>

<div class="page-title">
  <div class="page-title-text">
    <h3>Application Settings</h3>
  </div>

</div>

<div *ngIf="loading" class="config-skeleton">
  <p-card>
    <p-skeleton width="40%" height="1.5rem" styleClass="mb-3"></p-skeleton>
    <div class="skeleton-row" *ngFor="let i of [1, 2, 3]">
      <p-skeleton width="60%" height="1rem" styleClass="mb-2"></p-skeleton>
      <p-skeleton width="100%" height="2.5rem" styleClass="mb-3"></p-skeleton>
    </div>
  </p-card>
</div>

<div *ngIf="!loading" class="config-groups">
  <p-card *ngFor="let group of getGroupedConfigs()" class="config-card">
    <ng-template #header>
      <div class="card-header">
        <span>{{ group.category }}</span>
      </div>
    </ng-template>

    <div class="config-items">
      <div *ngFor="let config of group.items; let last = last" class="config-item">
        <div class="config-meta">
          <label class="config-label" [for]="config.key">
            {{ config.key }}
          </label>
          <span class="config-description" *ngIf="config.description">
            - ({{ config.description }})
          </span>
          <p-tag *ngIf="config.dirty" severity="warn" value="Modified" [rounded]="true" class="modified-tag"></p-tag>
        </div>
        <div class="config-input-row">
          <input
            pInputText
            type="number"
            [id]="config.key"
            [(ngModel)]="config.editValue"
            (ngModelChange)="onValueChange(config)"
            class="config-input"
            [class.modified]="config.dirty"
          />
          <p-button
            *ngIf="config.dirty"
            icon="pi pi-undo"
            severity="secondary"
            [outlined]="true"
            [rounded]="true"
            size="small"
            pTooltip="Reset to saved value"
            (onClick)="resetConfig(config)">
          </p-button>
        </div>
        <p-divider *ngIf="!last"></p-divider>
      </div>
    </div>
  </p-card>
  <div class="page-footer">
    <p-button
        [label]="'Save Changes' + (changedCount > 0 ? ' (' + changedCount + ')' : '')"
        icon="pi pi-check"
        severity="success"
        [disabled]="!hasChanges || saving"
        [loading]="saving"
        (onClick)="saveAll()"
        size="small">
    </p-button>
  </div>
</div>
